import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { DISABLE_USER, ENABLE_USER } from "./actionTypes";
import {
  disableUserSuccessful,
  disableUserFailed,
  enableUserSuccessful,
  enableUserFailed,
} from "./actions";

// Include call API
import { getUsersAPI } from "../../../api/users";

const usersAPI = getUsersAPI();

// Is user register successfull then direct plot user in redux.
function* disableUser({ payload: { user, token, history } }) {
  try {
    const response = yield call(usersAPI.disableUser, user, token);
    console.log(response);
    yield put(disableUserSuccessful(response.message));
    history.go();
  } catch (error) {
    yield put(disableUserFailed(error));
  }
}

function* enableUser({ payload: { user, token, history } }) {
  try {
    const response = yield call(usersAPI.enableUser, user, token);
    yield put(enableUserSuccessful(response.message));
    history.go();
  } catch (error) {
    yield put(enableUserFailed(error));
  }
}

export function* watchUserDisable() {
  yield takeEvery(DISABLE_USER, disableUser);
}

export function* watchUserEnable() {
  yield takeEvery(ENABLE_USER, enableUser);
}

function* statusUserSaga() {
  yield all([fork(watchUserDisable), fork(watchUserEnable)]);
}

export default statusUserSaga;
